export default "__VITE_ASSET__WJDH$iu3__"